import React from "react";
import { Routes, Route } from "react-router-dom";
import { Layout } from "antd";
import AppHeader from "./Components/AppHeader";
import AppSlider from "./Components/AppSlider";
import AppContent from "./Components/AppContent";
import AppFooter from "./Components/AppFooter";
import AsanaDetails from "./Components/main/AsanaDetails";

import Yoga from "./Components/Header/Yoga";
import Breathe from "./Components/Header/Breathe";
import Time from "./Components/Header/Time";
import Alternateasana from "./Components/Header/Alternateasana";
import Chakra from "./Components/Header/Chakra";
import Tool from "./Components/Header/Tool";

import Meditation from "./Components/Header/Meditation";
import DosAndDonts from "./Components/Header/DosAndDonts";
import Shatkarmas from "./Components/Header/Shatkarmas";


import Warmup from "./Components/Header/WarmUp";
import Mudra from "./Components/Header/Mudra";
import HowToMakeVariation from "./Pages/HowToMakeVariation";

import DictionaryPage from "./Components/Header/DictionaryPage";

const { Content } = Layout;

const App = () => {
  return (
    <Layout style={{ minHeight: "100vh" }}>
      <AppHeader />

      <Layout style={{ marginTop: 40 }}>
        <AppSlider />

        <Content
          className="overall"
          style={{ padding: 16, background: "#fff" }}
        >
          <Routes>
            <Route path="/" element={<AppContent />} />
            <Route path="/asanas/:slug" element={<AsanaDetails />} />
            {/* <Route path="/how-to-make-variation" element={<Makevariation />} /> */}
            <Route path="/yoga" element={<Yoga />} />
            <Route path="/alternate-asana" element={<Alternateasana />} />
            <Route
              path="/how-to-make-variation"
              element={<HowToMakeVariation />}
            />
            <Route path="/warm-up" element={<Warmup />} />
            <Route path="/breathe-technique" element={<Breathe />} />
            <Route path="/meditation" element={<Meditation />} />
            <Route path="/chakra" element={<Chakra />} />
            <Route path="/dos-and-donts" element={<DosAndDonts />} />
            <Route path="/mudra" element={<Mudra />} />
            <Route path="/shatkarmas" element={<Shatkarmas />} />
            <Route path="/tool" element={<Tool />} />
            <Route path="/time" element={<Time />} />
            <Route path="/dictionary" element={<DictionaryPage />} />
            {/* <Route path="/dummy-technique" element={<DummyBreathe />} /> */}
            {/* <Route path="/dummytool" element={<DummyTool />} /> */}
            {/* <Route path="/dummyMeditation" element={<DummyMeditation />} /> */}
            {/* <Route path="/demo-yoga" element={<DemoYoga />} /> */}
          </Routes>

          <AppFooter />
        </Content>
      </Layout>
    </Layout>
  );
};

export default App;
